import React from 'react';

import { ContentWrapper } from '../../../components/ContentWrapper/ContentWrapper';
import { SplitContent } from './SplitContent';
import { TextContent } from './TextContent';
import { isSection, isSequencedFlowItem, isSequencedFlowStep, Item, Section, SequencedFlowItem } from '@ael/core-api';

import './content-renderer.scss';
import {FroalaEditorsSettings} from "../../../../config/configs";

export interface ContentRendererProps {
  currentContentItem: Item;
  currentSectionItem: Section | SequencedFlowItem;
  onGoToSection: (section: Section) => void;
  froalaEditorsSettings: FroalaEditorsSettings;
}

export const ContentRenderer: React.FC<ContentRendererProps> = (props: ContentRendererProps) => {
  if (isSequencedFlowStep(props.currentContentItem)) {
    return (
      <ContentWrapper.Body noHorizontalPadding>
        <TextContent
          title={props.currentContentItem.title}
          body={props.currentContentItem.content}
          contentItem={props.currentContentItem}
          froalaEditorsSettings={props.froalaEditorsSettings}
        />
      </ContentWrapper.Body>
    );
  }
  if (isSection(props.currentContentItem)) {
    return (
      <ContentWrapper.Body>
        <SplitContent
          onGoToSection={props.onGoToSection}
          items={
            isSequencedFlowItem(props.currentSectionItem)
              ? props.currentSectionItem.contentItems
              : props.currentSectionItem.children
          }
        />
      </ContentWrapper.Body>
    );
  }
  return null;
};
